
import { apiSlice } from "./apiSlice";




export const orderSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        OrderListData: builder.mutation({
            query: (data) => (

                {
                    url: `order?${data}`,
                    method: 'GET',
                    credentials: "include",
                }),

        }),
        OrderInfoData: builder.mutation({
            query: (id) => ({
                method: "GET",
                url: 'order/' + id,
                credentials: "include",
            })
        }),
        OrderTrackingInfoData: builder.query({
            query: (id) => ({
                method: "GET",
                url: 'order/' + id,
                credentials: "include",
            }),
            providesTags: ['Order', 'orderStatus']
        }),
        OrderStatus: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: 'order/activity',
                credentials: "include",
                body: data,
            }),
            invalidatesTags: ['Order', 'orderStatus']
        }),
        OrderTrackingDelete: builder.mutation({
            query: (id) => ({
                url: '/order/activity/' + id,
                method: "DELETE",
                credentials: "include",
            }),
            invalidatesTags: ['Order']

        }),

        getStatisticsOrder: builder.query({
            query: (data) => ({
                url: 'order/statistics/order',
                method: "GET",
                credentials: "include",
            }),
            providesTags: ['Order'],
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    // dispatch(updateUser(arg));
                } catch (error) {
                    console.log(error);
                }
            },
        }),

        OrderCancelDelete: builder.mutation({
            query: (id) => ({
                url: '/order/' + id,
                method: "DELETE",
                // body: { id: id },
                credentials: "include",
            }),
            invalidatesTags: ['Order']

        }),
        orderUpdateTracking: builder.mutation({
            query: (data) => ({
                url: '/order/track',
                method: "POST",
                body: data,
                credentials: "include",
            }),


        }),
        orderInvoice: builder.mutation({
            query: (data) => ({


                method: 'GET',
                url: `/order/invoice/${data}`,
                credentials: 'include',

            })
        }),
    })
});
export const {
    useOrderInfoDataMutation,
    useOrderListDataMutation,
    useOrderStatusMutation,
    useOrderTrackingDeleteMutation,
    useGetStatisticsOrderQuery,
    useOrderCancelDeleteMutation,
    useOrderUpdateTrackingMutation,
    useOrderTrackingInfoDataQuery,
    useOrderInvoiceMutation
} = orderSlice;